import React, { useEffect, useRef, useState } from "react";
import {
  getCities,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";




const CollegeUniversityFeesStep4 = ({ data, setData, setCurrentStep, currentStep }) => {
  const navigate=useNavigate()


  const [cities, setCities] = useState([]);
  const [fetchCitiesLoading, setFetchCitiesLoading] = useState(false);

  const fetchCities = async () => {
    try {
      setFetchCitiesLoading(true);
      const res = await getCities();
      console.log("CDR20", res?.data);
      if (res?.status) {
        setCities(res?.data);
        setFetchCitiesLoading(false);
      } else {
        toast.error("Error while Fetching Cities Data");
        setFetchCitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Cities Data");
      console.error("Error fetching Districts:", error);
      setFetchCitiesLoading(false);
    }
  };

  const initialValues = {
    costOfLiving: data?.costOfLiving
  }
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          costOfLiving: formData?.costOfLiving
        })
        // setCurrentStep(currentStep)
        navigate("/manage-college-university");
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

  /////////////////////////////////////
  const initialItem = {
    city: "",
    hostelFees: 0,
    messFees: 0,
    totalAnnualCost: 0
  };

  const initialItems = data?.costOfLiving?.length ? data?.costOfLiving : [initialItem]

  const restructured = initialItems.map(item => ({
    ...item,
    city: item.city._id || item.city
  }));

  console.log("LOBB84", restructured);


  const [items, setItems] = useState(restructured);
  const handleMultiChange = (i, e) => {
    let newFormValues = [...items];
    if (e.target.name === "hostelFees" || e.target.name === "messFees" || e.target.name === "totalAnnualCost") {
      newFormValues[i][e.target.name] = parseInt(e.target.value);
    } else {
      newFormValues[i][e.target.name] = e.target.value;
    }

    setItems(newFormValues);
    setFormData({ ...formData, costOfLiving: newFormValues })
  };

  const addItem = () => {
    if (items?.length < 5000) {
      setItems([...items, initialItem]);
    }
  };

  const removeProducts = (i) => {
    let newFormValues = [...items];
    newFormValues.splice(i, 1);
    setItems(newFormValues);
    setFormData({ ...formData, costOfLiving: newFormValues })
  };

  useEffect(() => {
    fetchCities()
  }, [])

    useEffect(() => {
      setFormData(initialValues)
    }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            <div className="col-md-12 mt-3">
              <label>
                Cost of Living <button
                  className="btn btn-sm btn-success"
                  type="button"
                  onClick={() => addItem()}
                >
                  <i class="fas fa-plus"></i> Add
                </button>
              </label>
              {items?.map((element, index) => (

                <div
                  // style={{ border: "solid 1px #ced4da", padding: "1em", margin: "0 0 1em 0", borderRadius: "0.25rem" }}
                  className="_form-inline row" key={index}>

                  <div className="col-md-6 mb-2 mt-1">
                    <label>
                      City:
                    </label>
                    <select
                      name="city"
                      className="form-control"
                      value={element.city || ""}
                      onChange={(e) => handleMultiChange(index, e)}
                    >
                      <option value="">-------- Select City --------</option>
                      {fetchCitiesLoading ? (
                        <option>Loading...</option>
                      ) : cities?.length === 0 ? (
                        <option disabled>No City Found</option>
                      ) : (
                        cities?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.cityName}, {e?.district?.districtName} ({e?.state?.stateName})
                            </option>
                          );

                        })
                      )}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Hostel Fees:
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      name="hostelFees"
                      placeholder={`Amount ${index + 1}`}
                      value={element.hostelFees}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Mess Fees:
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      name="messFees"
                      placeholder={`Amount ${index + 1}`}
                      value={element.messFees}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  <div className="col-md-2 mb-2 mt-1">
                    <label>
                      Annual Cost:
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      name="totalAnnualCost"
                      placeholder={`Annual cost ${index + 1}`}
                      value={element.totalAnnualCost}
                      onChange={(e) => handleMultiChange(index, e)}
                    />
                  </div>

                  {index ? (
                    <div
                      style={{
                        position: "absolute",
                        right: "25px"
                      }}
                    >
                      <i class="fas fa-times"
                        style={{
                          color: "#ff0000",
                          cursor: "pointer",
                          fontSize: "1em"
                        }}
                        onClick={() => removeProducts(index)}
                      ></i>
                    </div>
                  ) : null}




                </div>

              ))}
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 2 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityFeesStep4;
